// src/components/CarrinhoItem.js
import React from 'react';
import './CarrinhoItem.css'; // Vamos criar este CSS mais tarde

function CarrinhoItem({ item, onAumentarQuantidade, onDiminuirQuantidade, onRemoverItem }) {
  // Calcular o preço por unidade (base + adicionais)
  const precoPorUnidade = item.precoUnitarioBase + item.adicionaisSelecionados.reduce((acc, adicional) => acc + adicional.preco, 0);

  return (
    <tr className="carrinho-item">
      <td>{item.nome}</td>
      <td>{item.tamanho}</td>
      <td>
        <div className="quantidade-control">
          <button onClick={() => onDiminuirQuantidade(item.produtoId, item.tamanho, item.adicionaisSelecionados)}>-</button>
          <span>{item.quantidade}</span>
          <button onClick={() => onAumentarQuantidade(item.produtoId, item.tamanho, item.adicionaisSelecionados)}>+</button>
        </div>
      </td>
      <td>R$ {item.precoTotalItem.toFixed(2)}</td>
      <td>
        <button className="remover-item-btn" onClick={() => onRemoverItem(item.produtoId, item.tamanho, item.adicionaisSelecionados)}>X</button>
      </td>
    </tr>
  );
}

export default CarrinhoItem;